import { ItineraryDetail } from '@seat-map/entities/itinerary-detail';
import { SeatMap, SeatMapErrors, SeatMapTransactions } from '@seat-map/entities/seat-map';

export const seatMapFeatureName = 'seatMapModuleState';

export type UISeatMapState = Readonly<{
  isLoadingSeatMap: boolean,
  isLoadingSeatMapFlight: boolean,
  showError: boolean
}>;

export type SeatMapModuleState = Readonly<{
  itineraryDetail: ItineraryDetail,
  seatMap: SeatMap,
  errors: SeatMapErrors,
  ui: UISeatMapState,
  transactions: SeatMapTransactions[]
}>;
